<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <!-- <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h1 class="text-white font-semibold text-5xl leading-normal">
                            استاد ویزیت، سامانه ویزیت و مشاوره آنلاین پزشکی
                        </h1>
                        <div class="relative flex w-full flex-wrap items-stretch mt-12"><span
                                class="z-10 h-full leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
                                    class="fa fa-search"></i></span><input type="text"
                                placeholder=" نام پزشک، نام بیماری، تخصص ... "
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full pl-10">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->


    <div class="bg-primary absolute top-0 w-full h-20 bg-center bg-cover">
        <span class="w-full h-full absolute" id="blackOverlay"></span>
    </div>

    <section class="pt-32 py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex justify-center">
                <div class="w-full lg:w-6/12 xl:w-8/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 shadow-lg">
                        <div class="flex justify-center">
                            <h5 class="font-semibold text-xl my-4"> اطلاعات ویزیت و مشاوره </h5>
                        </div>
                        <hr>
                        <div class="bg-primary-light text-primary my-4 p-4">
                            <div class="flex justify-around my-2 p-2">
                                <p> نام پزشک: </p>
                                <p> {{visit.doctorName}} </p>
                            </div>
                            <div class="flex justify-around my-2 p-2">
                                <p> نوع ویزیت: </p>
                                <p> {{visit.visitType==visitType.TextVisit?'متنی':visit.visitType==visitType.PhoneVisit?'صوتی':visit.visitType==visitType.VideoVisit?'تصویری':visit.visitType==visitType.BodyVisit?'حضوری':null}} </p>
                            </div>
                            <div class="flex justify-around my-2 p-2">
                                <p> تاریخ: </p>
                                <p> {{ visit.visitDate|shamsiDate }} </p>
                            </div>
                            <div class="flex justify-around my-2 p-2">
                                <p> ساعت: </p>
                                <p> {{convertUTCMinutesToLocal(visit.startVisit)}} </p>
                            </div>
                        </div>
                        <hr>
                        <div class="my-4 text-center">
                            <button *ngIf="visit.visitType!=visitType.BodyVisit" class="bg-primary text-white w-3/12 rounded py-3 mb-1 disabled:cursor-not-allowed disabled:bg-gray-200" type="button"
                                (click)="openVisitLink()" [disabled]="isActiveVisitLink()"> ورود </button>
                        </div>
                        <div class="my-6">
                            <p *ngIf="!isTodayVisit()"> تاریخ ویزیت:
                                {{ visit.visitDate|shamsiDate }}
                            </p>
                            <p *ngIf="isTodayVisit()"> زمان باقی مانده:
                                <span class="text-primary"> {{getRemainingTime(visit.startVisit)}}  </span>    
                                دقیقه
                            </p>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>

<p-toast dir="rtl"></p-toast>

<app-modal #modal>
    <!--header-->
    <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
        <h3 class="text-lg font-semibold">
            ثبت نظر
        </h3>
        <button
            class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
            (click)="modal.close()">
            <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
            </span>
        </button>
    </div>
    <!--body-->
    <div class="relative flex-auto ">
        <div class="relative flex justify-center p-2">
            <img alt="..."
                src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full max-w-120-px my-4">
            
        </div>
        <p class="my-4 text-blueGray-500 text-base text-start leading-relaxed">
            لطفا نظر خود را نسبت به ویزیت خانم/آقای دکتر ثبت کنید.
        </p>
        <div class="card flex justify-center">
            <p-rating [(ngModel)]="rateModel.rate" stars="5" />
        </div>
        <div class="relative w-full my-2 ">
            <!-- <label class="block text-blueGray-600 text-sm font-bold mb-2"> آدرس </label> -->
            <textarea type="text" [(ngModel)]="commentModel.comment" name="address" cols="80" rows="4" placeholder="لطفا توضیحات خود را اینجا وارد کنید"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"></textarea>
        </div>
    </div>
    <!--footer-->
    <div class="flex items-center justify-end py-2 border-solid border-blueGray-200 rounded-b">
        <!-- <button
            class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
            type="button" (click)="modal.close()">
            انصراف
        </button> -->
        <button
            class="bg-primary text-white font-bold text-base px-12 py-3 rounded shadow my-2 ease-linear transition-all duration-150"
            type="button" (click)="submitRating()">
            ثبت
        </button>
    </div>
</app-modal>